export class CdDssCspType {
    public ID: number;

    public Name: string;

    public Caption: string;

    constructor(
        id: number,
        name: string,
        caption: string
    ) {
        this.ID = id;
        this.Name = name;
        this.Caption = caption;
    }

    /** КЭП. */
    static Qualified = new CdDssCspType(0, "Qualified", "КЭП");

    /** НЭП. */
    static NonQualified = new CdDssCspType(1, "NonQualified", "НЭП");
}